import type { AdsActivityStatusVerdict } from "@/lib/adsAssistantClientEngagement";
import { resolveAdsActivityCta } from "@/components/ads-assistant/adsActivityCardCtaResolve";
import { focusFirstSelectInForm, scrollElementIntoViewById } from "@/components/ads-assistant/useAdsActivityCardScroll";

export function AdsActivityCardCta(props: {
  verdict: AdsActivityStatusVerdict | null | undefined;
  canOpenLibrary: boolean;
  hasManualForm: boolean;
  manualFormId: string;
  indexedAnchorId: string;
  onOpenLibraryTab?: () => void;
  onOpenIngestionTab?: () => void;
  onBeforeScrollToIndexedPosts?: () => void;
}) {
  const resolved = resolveAdsActivityCta({
    verdict: props.verdict,
    canOpenLibrary: props.canOpenLibrary,
    hasManualForm: props.hasManualForm,
  });
  if (resolved.kind === "none") return null;

  function onClick() {
    switch (resolved.kind) {
      case "scroll_manual":
        scrollElementIntoViewById(props.manualFormId);
        window.requestAnimationFrame(() => focusFirstSelectInForm(props.manualFormId));
        break;
      case "scroll_posts":
        props.onBeforeScrollToIndexedPosts?.();
        window.requestAnimationFrame(() => scrollElementIntoViewById(props.indexedAnchorId));
        break;
      case "open_library":
        props.onOpenLibraryTab?.();
        break;
      case "open_ingestion":
        props.onOpenIngestionTab?.();
        break;
      default:
        break;
    }
  }

  const controlsId =
    resolved.kind === "scroll_manual"
      ? props.manualFormId
      : resolved.kind === "scroll_posts"
        ? props.indexedAnchorId
        : undefined;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-controls={controlsId}
      className="mt-2 inline-flex items-center rounded-lg bg-blue-700 px-3 py-1.5 text-xs font-medium text-white hover:bg-blue-800 dark:bg-blue-600 dark:hover:bg-blue-500"
    >
      {resolved.label}
    </button>
  );
}
